import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";
import { OpenAIIcon } from "@gadgetinc/widgets/src/icons/OpenAIIcon";

const ChatGPTTutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>ChatGPT app tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn how to modify an MCP server and build widgets to build full stack ChatGPT apps.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Build a todo list"
            icon={<OpenAIIcon $size={32} />}
            color={colors.white}
            body="Learn how to modify an MCP server and build a todo list widget embedded in ChatGPT."
            href="/guides/tutorials/chatgpt/todo-list"
            copy="Build your first ChatGPT app →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ChatGPTTutorialsLandingPage;
